'use client';
import React from 'react';
import { CatButton } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import { useDealerLocatorDrawer } from 'components/dealer-locator/dealer-locator-drawer-context';

interface PartsCheckPriceProps {
  classNames?: string;
}
const PartsCheckPrice = ({ classNames = 'mb-1' }: PartsCheckPriceProps) => {
  const t = useTranslations();
  const drawerControl = useDealerLocatorDrawer();

  return (
    <CatButton
      size="sm"
      variant="contrast"
      onClick={() => drawerControl.openDrawer()}
      className={classNames}
    >
      {t('CAT_CHECK_PRICE')}
    </CatButton>
  );
};

export default PartsCheckPrice;
